export enum StreamQualityType {
    Low = "Low",
    Medium = "Medium",
    High = "High",
}
